import { useForm } from "@refinedev/react-hook-form";

import {
  LoginFormValues,
  loginSchema,
  ValidateFormValues,
  validateSchema,
} from "@modules/integration/validations";
import {
  useTestLoginIntegration,
  useTestValidateIntegration,
} from "@modules/integration/services/mutations/mutation";
import { zodResolver } from "@hookform/resolvers/zod";

export function useLoginIntegrationForm(onSuccess?: (data: any) => void) {
  const handleSuccess = (data: any) => {
    if (onSuccess) onSuccess(data);
  };

  const { mutateAsync, isPending } = useTestLoginIntegration({
    onSuccess: handleSuccess,
  });

  const methods = useForm<LoginFormValues>({
    resolver: zodResolver(loginSchema()),
    mode: "onBlur",
  });

  const {
    formState: { errors },
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}

export function useValidateIntegrationForm(onSuccess?: (data: any) => void) {
  const handleSuccess = (data: any) => {
    if (onSuccess) onSuccess(data);
  };

  const { mutateAsync, isPending } = useTestValidateIntegration({
    onSuccess: handleSuccess,
  });

  const methods = useForm<ValidateFormValues>({
    resolver: zodResolver(validateSchema()),
    mode: "onBlur",
  });

  const {
    formState: { errors },
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
